import React, { useState, useEffect } from 'react';

import { getRequest } from 'utils/api';
import Matches from './Matches';

const CloseMatches = ({ updateFollowingList }) => {
  const [closeMatchList, setCloseMatchList] = useState([]);
  const [hasMoreCloseMatches, setHasMoreCloseMatches] = useState(false);
  const [guaranteedGainsMatchList, setGuaranteedGainsMatchList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const updateCloseMatchGig = gig => {
    setCloseMatchList(prevState => prevState.map(g => (g.id === gig.id ? gig : g)));

    updateFollowingList(gig);
  };

  const fetchGuaranteedGainsMatches = ignoreIds =>
    getRequest({
      endpoint: 'gigs/guaranteed_gains',
      query: { per_page: 20, ignore_ids: ignoreIds },
      resolveResponse: true,
    })
      .then(response => {
        setGuaranteedGainsMatchList(response.status === 204 ? [] : [...response.data.gigs]);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    getRequest({
      endpoint: 'gigs/close_matches',
      query: { per_page: 5 },
      resolveResponse: true,
    })
      .then(response => {
        const data = response.status === 204 ? [] : [...response.data.gigs];
        const count = response.headers['pagination-total-count'] || 0;

        if (!isMounted) return;
        setHasMoreCloseMatches(+count > 5);
        setCloseMatchList(data);
        fetchGuaranteedGainsMatches(data.map(g => g.id));
      })
      .catch(() => setIsLoading(false));

    return () => (isMounted = false);
  }, []);

  return (
    <Matches
      gigs={closeMatchList}
      extraGigs={guaranteedGainsMatchList}
      updateGig={updateCloseMatchGig}
      link="discover/close-matches"
      title="Close Match"
      hasMore={hasMoreCloseMatches}
      isLoading={isLoading}
    />
  );
};

export default CloseMatches;
